import styled from "styled-components";
import desktop from "../../../assets/images/banner-flamengo/desktop.jpg";
import mobile from "../../../assets/images/banner-flamengo/mobile.jpg";

export const Container = styled.div`
  position: relative;
  display: flex;

  width: 100%;
  max-width: 1920px;
  min-height: 100px;
  margin: 0;
`;

export const DesktopBanner = styled.img.attrs({ src: desktop })`
  width: 100%;
  height: auto;
  z-index: 2;
  @media screen and (max-width: 580px) {
    display: none;
  }
`;
export const MobileBanner = styled.img.attrs({ src: mobile })`
  display: none;
  @media screen and (max-width: 580px) {
    display: block;
    width: 100%;
    height: auto;
  }
`;
